"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineChart = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var dimensions_1 = require("../_commons/dimensions");
var CoreLineChart_1 = require("./CoreLineChart");
var withChart_1 = require("../_base/withChart");
//
// Internals
//
function lineChartDimensions(def) {
    return dimensions_1.stackedChartDimensions(def, sdk_ui_1.BucketNames.TREND, sdk_ui_1.BucketNames.SEGMENT);
}
var lineChartDefinition = {
    chartName: "LineChart",
    bucketPropsKeys: ["measures", "trendBy", "segmentBy", "filters", "sortBy"],
    bucketsFactory: function (props) {
        return [
            sdk_model_1.newBucket.apply(void 0, tslib_1.__spreadArrays([sdk_ui_1.BucketNames.MEASURES], props.measures)),
            sdk_model_1.newBucket(sdk_ui_1.BucketNames.TREND, props.trendBy),
            sdk_model_1.newBucket(sdk_ui_1.BucketNames.SEGMENT, props.segmentBy),
        ];
    },
    executionFactory: function (props, buckets) {
        var _a;
        var backend = props.backend, workspace = props.workspace, execConfig = props.execConfig;
        return (_a = backend
            .withTelemetry("LineChart", props)
            .workspace(workspace)
            .execution()
            .forBuckets(buckets, props.filters))
            .withSorting.apply(_a, props.sortBy).withDimensions(lineChartDimensions)
            .withExecConfig(execConfig);
    },
};
var WrappedLineChart = withChart_1.withChart(lineChartDefinition)(CoreLineChart_1.CoreLineChart);
/**
 * [LineChart](http://sdk.gooddata.com/gooddata-ui/docs/line_chart_component.html)
 *
 * Line chart shows data as line-connected dots. Line charts can display either multiple measures as individual lines
 * or a single measure split by one attribute into multiple lines with points intersecting attribute values.
 *
 * @public
 */
exports.LineChart = function (props) {
    var _a = sdk_ui_1.useResolveValuesWithPlaceholders([props.measures, props.trendBy, props.segmentBy, props.filters, props.sortBy], props.placeholdersResolutionContext), measures = _a[0], trendBy = _a[1], segmentBy = _a[2], filters = _a[3], sortBy = _a[4];
    return (react_1.default.createElement(WrappedLineChart, tslib_1.__assign({}, props, {
        measures: measures,
        trendBy: trendBy,
        segmentBy: segmentBy,
        filters: filters,
        sortBy: sortBy,
    })));
};
//# sourceMappingURL=LineChart.js.map